export const indianStates = [
  { abbreviation: "AN", name: "Andaman and Nicobar Islands" },
  { abbreviation: "AP", name: "Andhra Pradesh" },
  { abbreviation: "AR", name: "Arunachal Pradesh" },
  { abbreviation: "AS", name: "Assam" },
  { abbreviation: "BR", name: "Bihar" },
  { abbreviation: "CG", name: "Chandigarh" },
  { abbreviation: "CH", name: "Chhattisgarh" },
  { abbreviation: "DH", name: "Dadra and Nagar Haveli" },
  { abbreviation: "DD", name: "Daman and Diu" },
  { abbreviation: "DL", name: "Delhi" },
  { abbreviation: "GA", name: "Goa" },
  { abbreviation: "GJ", name: "Gujarat" },
  { abbreviation: "HR", name: "Haryana" },
  { abbreviation: "HP", name: "Himachal Pradesh" },
  { abbreviation: "JK", name: "Jammu and Kashmir" },
  { abbreviation: "JH", name: "Jharkhand" },
  { abbreviation: "KA", name: "Karnataka" },
  { abbreviation: "KL", name: "Kerala" },
  { abbreviation: "LD", name: "Lakshadweep" },
  { abbreviation: "MP", name: "Madhya Pradesh" },
  { abbreviation: "MH", name: "Maharashtra" },
  { abbreviation: "MN", name: "Manipur" },
  { abbreviation: "ML", name: "Meghalaya" },
  { abbreviation: "MZ", name: "Mizoram" },
  { abbreviation: "NL", name: "Nagaland" },
  { abbreviation: "OR", name: "Odisha" },
  { abbreviation: "PY", name: "Puducherry" },
  { abbreviation: "PB", name: "Punjab" },
  { abbreviation: "RJ", name: "Rajasthan" },
  { abbreviation: "SK", name: "Sikkim" },
  { abbreviation: "TN", name: "Tamil Nadu" },
  { abbreviation: "TS", name: "Telangana" },
  { abbreviation: "TR", name: "Tripura" },
  { abbreviation: "UP", name: "Uttar Pradesh" },
  { abbreviation: "UK", name: "Uttarakhand" },
  { abbreviation: "WB", name: "West Bengal" },
];
